import React, { useId } from 'react';
import { FileType } from 'types/Files';

const GREEN_COLOR = '#1D9314';
const BLUE_COLOR = '#3b82f6';

const EXT_COLORS: Record<string, string> = {
    [FileType.PDF]: '#ef4444',
    [FileType.XLS]: GREEN_COLOR,
    [FileType.XLSX]: GREEN_COLOR,
    [FileType.CSV]: GREEN_COLOR,
    [FileType.PNG]: BLUE_COLOR,
    [FileType.JPG]: BLUE_COLOR,
    [FileType.JPEG]: BLUE_COLOR,
};

interface FileTypeIconProps {
    fileType: FileType;
    size?: number;
}

export default function FileTypeIcon({ fileType, size = 20 }: FileTypeIconProps): JSX.Element {
    const id = useId();
    const maskId = `ftm-${id}`;
    const color = EXT_COLORS[fileType] ?? '#94a3b8';

    return (
        <svg
            width={size}
            height={Math.round(size * 1.3)}
            viewBox="0 0 15 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M2.578 20H12.344C13.768 20 14.922 18.846 14.922 17.422V5.859L9.356 0H2.578C1.154 0 0 1.154 0 2.578V17.422C0 18.846 1.154 20 2.578 20Z"
                fill={color}
            />
            <mask
                id={maskId}
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="15"
                height="20"
            >
                <path
                    d="M2.578 20H12.344C13.768 20 14.922 18.846 14.922 17.422V5.859L9.356 0H2.578C1.154 0 0 1.154 0 2.578V17.422C0 18.846 1.154 20 2.578 20Z"
                    fill={color}
                />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path opacity="0.3" d="M9.336 -2.266H17.539V5.859H9.336V-2.266Z" fill="white" />
            </g>
            <text
                x="7.5"
                y="14.8"
                textAnchor="middle"
                fill="white"
                fontSize="4"
                fontWeight="700"
                fontFamily="system-ui, sans-serif"
            >
                {fileType.toUpperCase().slice(0, 4)}
            </text>
        </svg>
    );
}
